// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { InputBox } from '@imprivata-cloud/components';
import { useId } from 'react';
import CopyButton from '../copyButton/copyButton';
import './ReadOnlyCredentialRow.less';

interface ReadOnlyCredentialRowProps {
  label: string;
  value: string;
  ariaLabel?: string;
  href?: string;
}

const ReadOnlyCredentialRow = ({ label, value, ariaLabel, href }: ReadOnlyCredentialRowProps) => {
  const inputId = useId();
  return (
    <div className="credential-row">
      {/* Not InputBox's `label`: that renders inside `.impr-input-box`, which the IDV modal
          styles as a fixed-height field. */}
      {label && <label htmlFor={inputId}>{label}</label>}
      <div className="input-with-copy">
        {href ? (
          <a id={inputId} className="credential-link" href={href} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        ) : (
          <InputBox id={inputId} value={value} readOnly size="large" />
        )}
        <CopyButton
          textToCopy={value}
          dynamicLabel={{ initialLabel: '', labelAfterClick: '', dynamicLabelDuration: 2000 }}
          {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
        />
      </div>
    </div>
  );
};

export default ReadOnlyCredentialRow;
